import React, { useContext } from 'react'
import AppContext from '../../config/AppContext';
import { useTranslation } from 'react-i18next';
import "./style/CustomPlanSmallCard.scss"
import { Typography } from '@mui/material';
import CardButton from './CardButton';
import CommonUtil from '../../util/CommonUtils';

const CustomPlanSmallCard = ({ maxWidth = "auto",marginRight=0, ...props }) => {
    const { t } = useTranslation();
    const { mode } = useContext(AppContext);
    return (
        <div className='custom-plan-card-main'
            style={{
                // border: mode == "light" ? "1px dashed #1D0B77" : "1px dashed #EAEBEF",
                background: mode === "dark" ? "#6A6A6A" : "#EAEBEF ",
                maxWidth: maxWidth,
                marginRight:marginRight,
                backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='${encodeURIComponent(
                    mode == "dark" ? "#EAEBEF" : "#1D0B77"
                  )}' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`
            }}
        >
            <div className='custom-plan-card-content'>
                <Typography className={CommonUtil.getOS() === "MacOS"
                    ? "mac-custom-plan-name"
                    : "custom-plan-name"}
                    sx={{
                        color: mode == "light" ? "rgba(36, 36, 36, 0.8)" : "rgba(248, 248, 248, 0.8)"
                    }}
                >{t("RAL0837")}</Typography>
                <Typography className='custom-plan-description'
                    sx={{
                        color: mode == "light" ? "rgba(36, 36, 36, 0.8)" : "rgba(248, 248, 248, 0.8)"
                    }}
                >{t("RAL0836")}</Typography>
            </div>

            {/* <button className="custom-plan-card-button" >{t("RAL0835")}</button> */}
            <CardButton
                variant={"contained"}
                id="btn-contact-sales"
                name="btn-contact-sales"
                fullWidth={true}
                onClick={() => props.openCustomPlan(true)}
            >
                {t("RAL0835")}
            </CardButton>

        </div>
    )
}

export default CustomPlanSmallCard
